import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Observable, map } from 'rxjs';

import { BasicVerificationStatus, IDVerificationStatus } from '../models/verification-profile-response';
import { SummaryVerificationFacade } from '../state/facades/summary';

export const ResolveVerificationTypeGuard: CanActivateFn =
  (): Observable<UrlTree> => {
    const { summary$ } = inject(SummaryVerificationFacade);
    const router = inject(Router);

    return summary$.pipe(
      map(({basicStatus, idStatus}) => {
        if (basicStatus === BasicVerificationStatus.none && idStatus === IDVerificationStatus.none) {
          return router.createUrlTree(['profile', 'verification', 'route']);
        }
        if (basicStatus === BasicVerificationStatus.none && idStatus !== IDVerificationStatus.banned) {
          return router.createUrlTree(['profile', 'verification', 'express']);
        }
        return router.createUrlTree(['profile', 'verification', 'identity']);
      })
    )

  };
